import React from 'react';

import classNames from 'classnames';

import './Loader.scoped.scss';

interface Props {
  fade?: boolean;
}

const Loader: React.FC<Props> = ({ fade = true }) => {
  return <div className={classNames('loader', { loaderFade: fade })}></div>;
};

export default Loader;
